import {moment, round} from 'helpers';
import {format} from './convert';

export function status(status) {
  return {
    activity_id: status.taskId,
    count: status.completedCount,
    dailyResult: round(status.dailyResult || 0, 1),
    duration: parseInt(status.duration || '0'),
    id: status.taskStatusId,
    notes: status.notes,
    priority: status.priority,
    result: status.result,
    status: status.status,
    timestamp: moment(status.date, format).unix(),
    unit: status.unit,
  }
}
